module.exports = require("./../../_gen/starling/animation/IAnimatable");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/animation/IAnimatable.js
// module id = 128
// module chunks = 0